export enum TipoCartao {
    'Crédito' = 'Crédito',
    'Débito' = 'Débito'
}
